

export function initializeStep5() {
    
    const checkAcceptance = () => {
        let checkbox = document.querySelector('[name="acceptance-a"]');
        
        if(!checkbox.checked) {
            document.querySelector('.form_submit').classList.add('disabled')
        } else {
            document.querySelector('.form_submit').classList.remove('disabled')
        }
    }

    checkAcceptance();

    document.querySelector('[name="acceptance-a"]').addEventListener('change', () => {
        checkAcceptance();
    });


    const submitBtn = document.querySelector('.form_submit');
    submitBtn.addEventListener('click', () => {
        document.querySelector('#real_btn_submit').click();
    });
}